export const profile = {
  en: {
    "profile.my_profile": "My Profile",
    "profile.full_name": "Full name",
    "profile.email": "Email",
    "profile.birth": "Date of birth",
    "profile.v_status": "Verification status",
    "profile.start_verification": "Start verification",
    "profile.phone_number": "Phone number",
    "profile.timezone": "Time Zone",
    "profile.nothing_found": "Nothing found",
    "profile.country": "Country",
    "profile.business_profile": "Business Profile",
    "profile.trading_profile": "Trading Profile",
    "profile.company_name": "Company name",
    "profile.business_id": "Business ID",
    "profile.business_email": "Business email",
    "profile.business_phone": "Business phone",
    "profile.tax_id": "Tax ID",
    "profile.registration_number": "Registration number",
    "profile.business_information": "Business information",
    "profile.trade_profile": "Trade profile",
    "profile.trading_commission_rate": "Trading commission rate",
    "profile.advantages_invitation": "Advantages of the invitation",
    "profile.business_user": "Business user",
    "profile.account_details": "Account details",
    "profile.nickname": "Nickname",
    "profile.user_id": "User ID",
    "profile.date_of_birth": "Date of birth",
    "profile.verification_information": "Verification information",
    "profile.verification_kyc": "Verification (KYC)",
    "profile.verification_missing_data":
      "Before uploading documents, please complete the following information:",
    "profile.verification_kyc_get": "Get verified",
    "profile.verification_fill_first_and_last_name":
      "Enter your first and last name as shown on your document",
    "profile.verification_fill_first_name":
      "Enter your first name as shown on your document",
    "profile.verification_fill_last_name":
      "Enter your last name as shown on your document",
    "profile.country_region": "Country/region",
    "profile.regular_user": "Regular user",
    "profile.nickname_description":
      "Your nickname is used for trading and in-app messages",
    "profile.enter_nickname": "Enter nickname",
    "profile.nickname_changes_remaining": "Your nickname can be edited",
    "profile.more_times_this_year": "more time(s) this year",
    "profile.hey": "Hey",
    "profile.profile_name": "Profile Name",
    "profile.field_cannot_be_empty": "This field cannot be empty",
    "profile.phone_incomplete": "Enter the full phone number",
    "profile.nickname_max_length": "Nickname must be at most 255 characters",
    "profile.date_error_empty": "Please fill in all date fields",
    "profile.date_error_day": "Day must be between 1 and 31",
    "profile.date_error_month": "Month must be between 1 and 12",
    "profile.date_error_year_format": "Year must be 4 digits",
    "profile.date_error_invalid": "Invalid date",
    "profile.date_error_future": "Date of birth cannot be in the future",
    "profile.date_error_age_min": "You must be at least 18 years old",
    "profile.date_error_age_max": "Please enter a valid date of birth",
    "profile.trader_profile": "Trader profile",
    "profile.personal_information": "Personal information",
    "profile.first_name": "First name",
    "profile.last_name": "Last name",
    "profile.verification": "Verification",
    "profile.settings": "Settings",
  },

  ru: {
    "profile.my_profile": "Мой профиль",
    "profile.full_name": "Имя и фамилия",
    "profile.email": "E-mail",
    "profile.birth": " Дата рождения",
    "profile.v_status": "Статус проверки",
    "profile.start_verification": "Начать проверку",
    "profile.phone_number": "Номер телефона",
    "profile.country": "Страна",
    "profile.timezone": "Часовой пояс",
    "profile.nothing_found": "Ничего не найдено",
    "profile.business_profile": "Бизнес профиль",
    "profile.trading_profile": "Торговый профиль",
    "profile.company_name": "Название компании",
    "profile.business_id": "Бизнес ID",
    "profile.business_email": "Бизнес email",
    "profile.business_phone": "Бизнес телефон",
    "profile.tax_id": "Налоговый номер",
    "profile.registration_number": "Регистрационный номер",
    "profile.business_information": "Бизнес информация",
    "profile.trade_profile": "Торговый профиль",
    "profile.trading_commission_rate": "Торговая комиссия",
    "profile.advantages_invitation": "Преимущества приглашения",
    "profile.business_user": "Бизнес пользователь",
    "profile.account_details": "Детали аккаунта",
    "profile.nickname": "Никнейм",
    "profile.user_id": "ID пользователя",
    "profile.date_of_birth": "Дата рождения",
    "profile.verification_information": "Информация о верификации",
    "profile.verification_kyc": "Верификация (KYC)",
    "profile.verification_missing_data":
      "Перед загрузкой документов, пожалуйста, заполните следующие данные:",
    "profile.verification_kyc_get": "Пройти верификацию",
    "profile.verification_fill_first_and_last_name":
      "Укажите имя и фамилию как в документе",
    "profile.verification_fill_first_name": "Укажите имя как в документе",
    "profile.verification_fill_last_name": "Укажите фамилию как в документе",
    "profile.country_region": "Страна/регион",
    "profile.regular_user": "Обычный пользователь",
    "profile.nickname_description":
      "Ваш никнейм используется для торговли и сообщений в приложении",
    "profile.enter_nickname": "Введите никнейм",
    "profile.nickname_changes_remaining": "Ваш никнейм можно изменить",
    "profile.more_times_this_year": "раз(а) в этом году",
    "profile.hey": "Привет",
    "profile.profile_name": "Имя профиля",
    "profile.field_cannot_be_empty": "Поле не может быть пустым",
    "profile.phone_incomplete": "Введите полный номер телефона",
    "profile.nickname_max_length": "Никнейм не должен быть длиннее 255 символов",
    "profile.date_error_empty": "Пожалуйста, заполните все поля даты",
    "profile.date_error_day": "День должен быть от 1 до 31",
    "profile.date_error_month": "Месяц должен быть от 1 до 12",
    "profile.date_error_year_format": "Год должен состоять из 4 цифр",
    "profile.date_error_invalid": "Неверная дата",
    "profile.date_error_future": "Дата рождения не может быть в будущем",
    "profile.date_error_age_min": "Вам должно быть не менее 18 лет",
    "profile.date_error_age_max":
      "Пожалуйста, введите корректную дату рождения",
    "profile.trader_profile": "Профиль трейдера",
    "profile.personal_information": "Личная информация",
    "profile.first_name": "Имя",
    "profile.last_name": "Фамилия",
    "profile.verification": "Верификация",
    "profile.settings": "Настройки",
  },

  es: {
    "profile.my_profile": "Mi perfil",
    "profile.full_name": "Nombre completo",
    "profile.email": "Correo electrónico",
    "profile.birth": "Fecha de nacimiento",
    "profile.v_status": "Estado de verificación",
    "profile.start_verification": "Comenzar verificación",
    "profile.phone_number": "Número de teléfono",
    "profile.country": "País",
    "profile.timezone": "Zona horaria",
    "profile.nothing_found": "No se encontró nada",
    "profile.business_profile": "Perfil comercial",
    "profile.trading_profile": "Perfil de trading",
    "profile.company_name": "Nombre de la empresa",
    "profile.business_id": "ID comercial",
    "profile.business_email": "Email comercial",
    "profile.business_phone": "Teléfono comercial",
    "profile.tax_id": "Número de identificación fiscal",
    "profile.registration_number": "Número de registro",
    "profile.business_information": "Información comercial",
    "profile.trade_profile": "Perfil comercial",
    "profile.trading_commission_rate": "Tasa de comisión comercial",
    "profile.advantages_invitation": "Ventajas de la invitación",
    "profile.business_user": "Usuario comercial",
    "profile.account_details": "Detalles de la cuenta",
    "profile.nickname": "Apodo",
    "profile.user_id": "ID de usuario",
    "profile.date_of_birth": "Fecha de nacimiento",
    "profile.verification_information": "Información de verificación",
    "profile.verification_kyc": "Verificación (KYC)",
    "profile.verification_missing_data":
      "Antes de subir los documentos, completa la siguiente información:",
    "profile.verification_kyc_get": "Verificarse",
    "profile.verification_fill_first_and_last_name":
      "Introduce tu nombre y apellido tal como aparecen en tu documento",
    "profile.verification_fill_first_name":
      "Introduce tu nombre tal como aparece en tu documento",
    "profile.verification_fill_last_name":
      "Introduce tu apellido tal como aparece en tu documento",
    "profile.country_region": "País/región",
    "profile.regular_user": "Usuario regular",
    "profile.nickname_description":
      "Tu apodo se usa para operar y mensajes en la aplicación",
    "profile.enter_nickname": "Ingresa apodo",
    "profile.nickname_changes_remaining": "Tu apodo se puede editar",
    "profile.more_times_this_year": "vez(ces) más este año",
    "profile.hey": "Hola",
    "profile.profile_name": "Nombre del perfil",
    "profile.field_cannot_be_empty": "Este campo no puede estar vacío",
    "profile.phone_incomplete": "Introduce el número de teléfono completo",
    "profile.nickname_max_length": "El apodo no puede tener más de 255 caracteres",
    "profile.date_error_empty": "Por favor, complete todos los campos de fecha",
    "profile.date_error_day": "El día debe estar entre 1 y 31",
    "profile.date_error_month": "El mes debe estar entre 1 y 12",
    "profile.date_error_year_format": "El año debe tener 4 dígitos",
    "profile.date_error_invalid": "Fecha inválida",
    "profile.date_error_future":
      "La fecha de nacimiento no puede estar en el futuro",
    "profile.date_error_age_min": "Debe tener al menos 18 años",
    "profile.date_error_age_max":
      "Por favor, ingrese una fecha de nacimiento válida",
    "profile.trader_profile": "Perfil de trader",
    "profile.personal_information": "Información personal",
    "profile.first_name": "Nombre",
    "profile.last_name": "Apellido",
    "profile.verification": "Verificación",
    "profile.settings": "Configuración",
  },

  ua: {
    "profile.my_profile": "Мій профіль",
    "profile.full_name": "Повне ім’я",
    "profile.email": "Електронна пошта",
    "profile.birth": "Дата народження",
    "profile.v_status": "Статус верифікації",
    "profile.start_verification": "Почати верифікацію",
    "profile.phone_number": "Номер телефону",
    "profile.country": "Країна",
    "profile.timezone": "Часовий пояс",
    "profile.nothing_found": "Нічого не знайдено",
    "profile.business_profile": "Бізнес профіль",
    "profile.trading_profile": "Торговий профіль",
    "profile.company_name": "Назва компанії",
    "profile.business_id": "Бізнес ID",
    "profile.business_email": "Бізнес email",
    "profile.business_phone": "Бізнес телефон",
    "profile.tax_id": "Податковий номер",
    "profile.registration_number": "Реєстраційний номер",
    "profile.business_information": "Бізнес інформація",
    "profile.trade_profile": "Торговий профіль",
    "profile.trading_commission_rate": "Торгова комісія",
    "profile.advantages_invitation": "Переваги запрошення",
    "profile.business_user": "Бізнес користувач",
    "profile.account_details": "Деталі акаунту",
    "profile.nickname": "Нікнейм",
    "profile.user_id": "ID користувача",
    "profile.date_of_birth": "Дата народження",
    "profile.verification_information": "Інформація про верифікацію",
    "profile.verification_kyc": "Верифікація (KYC)",
    "profile.verification_missing_data":
      "Перш ніж завантажувати документи, будь ласка, заповніть такі дані:",
    "profile.verification_kyc_get": "Пройти верифікацію",
    "profile.verification_fill_first_and_last_name":
      "Заповніть ім’я та прізвище як у документі",
    "profile.verification_fill_first_name": "Заповніть ім’я як у документі",
    "profile.verification_fill_last_name": "Заповніть прізвище як у документі",
    "profile.country_region": "Країна/регіон",
    "profile.regular_user": "Звичайний користувач",
    "profile.nickname_description":
      "Ваш нікнейм використовується для торгівлі та повідомлень у додатку",
    "profile.enter_nickname": "Введіть нікнейм",
    "profile.nickname_changes_remaining": "Ваш нікнейм можна редагувати",
    "profile.more_times_this_year": "раз(ів) на рік",
    "profile.hey": "Привіт",
    "profile.profile_name": "Ім'я профілю",
    "profile.field_cannot_be_empty": "Поле не може бути порожнім",
    "profile.phone_incomplete": "Введіть повний номер телефону",
    "profile.nickname_max_length": "Нікнейм не може бути довшим за 255 символів",
    "profile.date_error_empty": "Будь ласка, заповніть усі поля дати",
    "profile.date_error_day": "День має бути від 1 до 31",
    "profile.date_error_month": "Місяць має бути від 1 до 12",
    "profile.date_error_year_format": "Рік має складатися з 4 цифр",
    "profile.date_error_invalid": "Невірна дата",
    "profile.date_error_future": "Дата народження не може бути в майбутньому",
    "profile.date_error_age_min": "Вам має бути не менше 18 років",
    "profile.date_error_age_max":
      "Будь ласка, введіть коректну дату народження",
    "profile.trader_profile": "Профіль трейдера",
    "profile.personal_information": "Інформація про особу",
    "profile.first_name": "Ім’я",
    "profile.last_name": "Прізвище",
    "profile.verification": "Верифікація",
    "profile.settings": "Налаштування",
  },
};

export default profile;
